<template>
    <div>
        <el-dialog
            title="外委"
            :fullscreen="dialogFull"
            :close-on-click-modal="false"
            :destroy-on-close="true"
            :visible.sync="dialogShow"
            width="50%"
            :before-close="handleClose"
            append-to-body
            :modal-append-to-body="false">
            <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                       外 委
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>

                        </div>
                        <el-divider></el-divider>
                </template>
            <avue-form
                :option="option"
                v-model="form"
                v-if="dialogShow"
                @submit="formSubmit"
                @error="formError">
                 <template slot="remark">
                        <div>
                            <el-input
                                type="textarea"
                                :rows="3"
                                maxlength="500"
                                show-word-limit
                                placeholder="请输入 备注"
                                v-model="form.remark">
                            </el-input>
                            <remarkModel :remark.sync="form.remark" ref="scrapFormRemarkModel"></remarkModel>
                        </div>
                    </template>
                     <template slot="attachList">
                        <div>
                            <vupload :fileList.sync="form.attachList"></vupload>
                        </div>
                    </template>
                <template slot="menuForm">
                    <el-button @click="handleClose" ><span class="el-icon-close"></span> 取 消</el-button>
                </template>
            </avue-form>
        </el-dialog>
    </div>
</template>
<script>
import {

    outsourcingFormOption,
} from "./course-dialog-form-option";
import remarkModel from "./remark-model";
import {
        outsourcing,
        getContractList,
        getRemarkList} from "@/api/crmedical/order/order-list/order-list";
import vupload from "@/views/components/v-upload";
import {fieldDetail} from "@/api/v4ward/ordersetting/setting/selfForm"

export default {
    components:{
        remarkModel,vupload
    },
    data(){
        return{
            dialogFull:false,
            form:{
                orderId:'',
            },
            projectId:'',
            cheackedPeople:[],
            userList:[],
            dialogShow:false,
            option:outsourcingFormOption,
            contractList:[],
            imgRequireFlag:false
        }
    },
    watch:{
        'form.contractId'(){
             this.form.partnerId = ''
            this.contractList.forEach(ele=>{
                if(ele.contractId==this.form.contractId){
                    console.log(1213)
                    this.form.partnerId = ele.partnerId
                }

            })

        }
    },
    methods:{
        //获取字段填写修饰
        async getFieldDetail(projectId,moduleType,actionType){
            console.log("执行了")
            let obj = {
                projectId:projectId,
                moduleType:moduleType,
                actionType:actionType
            }
            let fieldObj
            fieldObj  = this.findObject(this.option.column,'contractId')
            await fieldDetail(obj).then(res=>{
                let resUploadFile
                let resContractName
                res.data.forEach(item=>{
                    if(item.fieldCode == "uploadFile"){
                        resUploadFile =item
                    }
                    if(item.fieldCode == "contractName"){
                        resContractName =item
                    }
                })
            if(resUploadFile){
                if( resUploadFile.defaultMustFlag ==0){

                    this.imgRequireFlag=false
                }else{
                    this.imgRequireFlag=true
                }
            }
            if(resContractName){
                if( resContractName.defaultMustFlag ==0){

                fieldObj.rules[0].required=false
                }else{
                    fieldObj.rules[0].required=true
                }
            }


            })
        },
        // 弹窗关闭前
        handleClose(done){
                let self = this;
                this.$confirm('确认关闭?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                })
                .then(()=> {

                        self.dialogShow = false;

                })
                .catch(()=> {

                });
        },
        openDialog(data){
            let orderRow = data.orderRow
                 this.getFieldDetail(orderRow.projectId,orderRow.moduleType,15)

            this.dialogShow = true;
            console.log("openDialog")
            this.form = {
                orderId:data.orderId
            }
            this.projectId = data.projectId;
            getRemarkList({orderId:data.orderId,actionType:data.actionType}).then(res=>{
                this.$refs.scrapFormRemarkModel.setRemarkList(res.data);
            })
            getContractList({projectId:this.projectId}).then(res=>{
                this.contractList = res.data;
                const column1 = this.findObject(this.option.column, "contractId");
                column1.dicData =  this.contractList;
                const column2 = this.findObject(this.option.column, "partnerId");
                column2.dicData =  this.contractList;

            })
        },
        closeDialog(){
            this.dialogShow = false;
        },
        formSubmit(form,done){
            if(this.imgRequireFlag){
                if(this.form.attachList.length==0){
                    this.$message.error("请上传照片或视频")
                    done()
                    return
                }
            }
            outsourcing(this.form).then(res=>{
                if(res.msg=='操作成功'){
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                     this.dialogVisible = false;
                     this.dialogShow = false;
                }else{
                    this.$message.error(res.msg);
                }
                this.$emit('handleClose',function(){console.log('关闭历程表')})

                this.dialogShow = false;
                done()
            }).catch(err=>{


                done()
            })
        },
    }
}
</script>
